module.exports = __webpack_public_path__ + "img/bl.3b115f24.png";